import React, { useContext } from "react";
import { StateContext } from "../../store/context";
import { format, parse, parseISO } from "date-fns";
import { TitleArea } from "../../components/Typography/titleArea";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./customerProfile.theme.css";


interface CustomerProfileProps {}

const CustomerProfile: React.FC<CustomerProfileProps> = () => {
  const { authUser } = useContext(StateContext);
  console.log({ authUser });

  return (
    <div className="vi-cp vi-glass-sheen flex w-full  bg-white min-h-full">
      <div className="flex flex-col w-full p-4">
        <div className="flex justify-between mb-8">
          <TitleArea
            variant="page"
            title="My Profile"
            subTitle="Write something about what is included in the profile section"
          />
        </div>
        <div className="flex w-full flex-col">
          <hr className="hr-line" />
          <div className="vi-glass-card flex flex-col mt-4 w-full px-6 py-2">
            <div className="flex w-full items-center justify-between py-4">
              <h2 className=" font-inter text-[#344054] text-[14px] font-normal w-4/12 ">
                Full Name
              </h2>
              <div className=" flex w-8/12 items-center gap-x-2">
                <input
                  value={authUser?.fullName?.split(" ")[0] || ""}
                  className=" bg-[#F9FAFB] border font-inter text-[#667085]  border-[#D0D5DD] rounded-[8px]"
                />
                <input
                  value={authUser?.fullName?.split(" ")[1] || ""}
                  className=" bg-[#F9FAFB] border font-inter text-[#667085]  border-[#D0D5DD] rounded-[8px]"
                />
              </div>

              {/* <Caption classes="font-[quicksand-semibold]">
                {authUser?.fullName}
              </Caption> */}
            </div>
            <hr className="mb-5" />
            <div
              className="flex w-full !py-[20px]"
              style={{
                paddingBlock: "26px",
              }}
            >
              <h2 className=" font-inter text-[#344054] text-[14px] font-normal w-4/12 ">
                Email address
              </h2>
              <div className=" flex w-8/12 items-center gap-x-2">
                <input
                  value={authUser?.email}
                  className=" bg-[#F9FAFB] border font-inter w-full text-[#667085]  border-[#D0D5DD] rounded-[8px]"
                />
              </div>
            </div>
            <hr className="mb-5" />
            <div
              className="flex w-full !py-[20px]"
              style={{
                paddingBlock: "26px",
              }}
            >
              <h2 className=" font-inter text-[#344054] text-[14px] font-normal w-4/12 ">
                Phone Number
              </h2>
              <div className=" flex w-8/12 items-center gap-x-2">
                <input
                  value={authUser?.mobile_number}
                  className=" bg-[#F9FAFB] border font-inter w-full text-[#667085]  border-[#D0D5DD] rounded-[8px]"
                />
              </div>
            </div>
            <hr className="mb-5" />
            <div
              className="flex w-full !py-[20px]"
              style={{
                paddingBlock: "26px",
              }}
            >
              <h2 className=" font-inter text-[#344054] text-[14px] font-normal w-4/12 ">
                Subscription Details
              </h2>
              <div className=" flex w-8/12 items-center gap-x-2">
                <div className="flex flex-col items-start w-full ">
                  <h3 className=" font-inter text-[#344054] text-[14px]">
                    {authUser?.sub_plan}
                  </h3>
                  <p className="font-inter text-[#667085] text-[14px] leading-relaxed">
                    {authUser?.sub_plan !== "Premium Plan" &&
                      `To upgrade or change your plan:`}
                    <br />
                    <span className="text-[#0075E3] block mt-1">
                      Contact us:
                      <ul className="list-disc pl-5 mt-1 space-y-1">
                        <li>+94 77 760 9615</li>
                        <li>+974 3003 2941</li>
                        <li>
                          <a
                            href="mailto:info@valueit.io"
                            className="underline"
                          >
                            info@valueit.io
                          </a>
                        </li>
                      </ul>
                    </span>
                  </p>
                  <div className="flex items-center gap-x-2 mt-4 w-full">
                    <div className=" flex flex-col w-full">
                      <h2 className=" text-[#344054] font-[500] text-[14px] font-inter">
                        Start Date
                      </h2>
                      <h3 className=" text-[#667085] font-normal text-[14px] font-inter">
                        {format(
                          parseISO(authUser?.sub_start_date),
                          "dd MMM yyyy"
                        )}
                      </h3>
                    </div>
                    <div className=" flex flex-col w-full">
                      <h2 className=" text-[#344054] font-[500] text-[14px] font-inter">
                        End Date
                      </h2>
                      <h3 className=" text-[#667085] font-normal text-[14px] font-inter">
                        {format(
                          parseISO(authUser?.sub_end_date),
                          "dd MMM yyyy"
                        )}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerProfile;
